import { z } from "zod";

/* A schema that turns Lizard date strings into Javascript Dates first and then validates them. */

export const lizardDateSchema = z.preprocess((arg) => {
  if (typeof arg === "string") {
    return new Date(arg);
  } else {
    return undefined;
  }
}, z.date());
